export const VALUELIST_REFRESH = 'VALUELIST_REFRESH';
export const FIELDS_REFRESH = 'FIELDS_REFRESH';
export const ROLES_REFRESH = 'ROLES_REFRESH';
export const DATA_GRID_REFRESH_TOTAL = 'DATA_GRID_REFRESH_TOTAL';
export const CRONS_REFRESH = 'CRONS_REFRESH';
export const PARAMETERS_REFRESH = 'PARAMETERS_REFRESH';
export const WIDGETS_REFRESH = 'WIDGETS_REFRESH';
export const FORMS_REFRESH = 'FORMS_REFRESH';
export const LITERALS_REFRESH = 'LITERALS_REFRESH';
export const CUSTOM_VALIDATIONS_REFRESH = 'CUSTOM_VALIDATIONS_REFRESH';
export const API_KEYS_REFRESH = 'API_KEYS_REFRESH';
export const REFRESH_IMPORT_LIST = 'REFRESH_IMPORT_LIST';
export const REFRESH_IMPORT_AFTER_CREATE_FIELD = 'REFRESH_IMPORT_AFTER_CREATE_FIELD';
export const INTEGRATIONS_REFRESH = 'INTEGRATIONS_REFRESH';
export const REFRESH_FORCE_BI_VISUALS = 'REFRESH_FORCE_BI_VISUALS';